let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("63zHi")).then(() => parcelRequire('jvel0'));